export const getReferencePath = (): string => {
  try {
    return btoa(location.protocol + '//' + location.host + location.pathname);
  } catch {
    return '';
  }
};
